import { XmlCursorPos, XMLCursorPositions } from '../cursor/xmlCursorPos.class';
import { Xml2html } from '../xml-html-converter/xml2html.class';

export class XmlEditRuleCheckTextInsert {
  namespacePraefix = 'xs:';

  constructor(private xsdNodes: Map<string, Element>) {}

  isTextAllowedAtThisCursorPos(cursorPosToCheck: XmlCursorPos): boolean {
    if (!cursorPosToCheck) {
      return false;
    }
    const parentNode = this.getRelevantParentNodeForCursorPos(cursorPosToCheck);
    const parentName = Xml2html.getTagNameFromNode(parentNode);
    const xsdNode = this.xsdNodes.get(parentName);
    if (xsdNode) {
      const result = this.isTextAllowedInThisElement(xsdNode);
      return result;
    } else {
      return false; // element not found
    }
  }

  getRelevantParentNodeForCursorPos(cursorPosToCheck: XmlCursorPos): Node {
    if (cursorPosToCheck) {
      let parentNode = cursorPosToCheck.ActualNode;

      switch (parentNode.nodeType) {
        case Node.COMMENT_NODE:
        case Node.TEXT_NODE:
          parentNode = parentNode.parentElement;
          break;

        case Node.ELEMENT_NODE:
          switch (cursorPosToCheck.PosAtNode) {
            case XMLCursorPositions.CursorInEmptyNode:
            case XMLCursorPositions.CursorInsideTextNode:
              break;

            case XMLCursorPositions.CursorBehindNode:
            case XMLCursorPositions.CursorInFrontOfNode:
            case XMLCursorPositions.CursorOnCompleteNode:
              parentNode = parentNode.parentElement;
              break;

            default:
              throw new Error(`unhandled  cursorPosToCheck.PosAmNode "${cursorPosToCheck.PosAtNode}"/${XmlCursorPos.getXmlCursorPositionDebugName(cursorPosToCheck.PosAtNode)}" `);
          }
          break;

        default:
          throw new Error(`unhandled  parentNode.nodeType "${parentNode.nodeType}"`);
      }
      return parentNode;
    }
  }

  isTextAllowedInThisElement(xsdNode: Node, alreadyAddedElementNames: Set<string> = new Set<string>()): boolean {
    let elementName: string;

    if (xsdNode.nodeType === Node.ELEMENT_NODE) {
      const asElem = xsdNode as Element;
      if (asElem) {
        const mixedAttrib = asElem.getAttribute('mixed');
        if (mixedAttrib) {
          return true;
        }
        const typeAttrib = asElem.getAttribute('type');
        if (typeAttrib && typeAttrib === `${this.namespacePraefix}string`) {
          return true;
        }

        if (asElem.localName === 'element') {
          elementName = asElem.getAttribute('name');
          if (elementName) {
            if (alreadyAddedElementNames.has(elementName)) {
              return false; // element recursion detected
            }
          }
          alreadyAddedElementNames.add(elementName);
        }
      }
    }

    const childNodes = Array.prototype.slice.call(xsdNode.childNodes) as Node[];

    let allowed = false;

    childNodes.forEach(child => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        const childElem = child as Element;
        if (childElem) {
          switch (childElem.localName) {
            case 'complexType':
            case 'sequence':
            case 'choice':
            case 'simpleContent':
            case 'extension':
              if (this.isTextAllowedInThisElement(child, alreadyAddedElementNames) === true) {
                allowed = true;
                break;
              }
              break;

            case 'element':
              const refname = childElem.attributes.getNamedItem('ref');
              if (refname) {
                const referedNode = this.xsdNodes.get(refname.value);
                if (referedNode) {
                  if (this.isTextAllowedInThisElement(referedNode, alreadyAddedElementNames) === true) {
                    allowed = true;
                    break;
                  }
                } else {
                  throw new Error(` refered element "${refname}" for element "${childElem.outerHTML}" not found`);
                }
              }
              break;

            case 'attribute':
              break;

            default:
              alert('unknown childElem.localname "' + childElem.localName + '"/' + childElem.outerHTML);
          }
        }
      }
    });

    return allowed;
  }
}
